var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#DC4405",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17V21.8022C20.5 21.9222 20.5715 22.0307 20.6818 22.0779L24 23.5",
    stroke: "#DC4405",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11C19.0222 11 17.0888 11.5865 15.4443 12.6853C13.7998 13.7841 12.5181 15.3459 11.7612 17.1732C11.0043 19.0004 10.8063 21.0111 11.1921 22.9509C11.578 24.8907 12.5304 26.6725 13.9289 28.0711C15.3275 29.4696 17.1093 30.422 19.0491 30.8078C20.9889 31.1937 22.9996 30.9957 24.8268 30.2388C26.6541 29.4819 28.2159 28.2002 29.3147 26.5557C30.4135 24.9112 31 22.9778 31 21C30.9923 18.3502 29.9363 15.8111 28.0626 13.9374C26.1889 12.0637 23.6498 11.0076 21 11Z",
    stroke: "#DC4405",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingAccess);
export default __webpack_public_path__ + "static/media/upcoming-access.74d74b6edad1a1268b7d9e66dae9488f.svg";
export { ForwardRef as ReactComponent };